import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (state, action) => ({ message: action.payload }),
    clearMessage: () => ({ message: '' }),
  },
});

export const { setMessage, clearMessage } = messageSlice.actions;

export default messageSlice.reducer;

export const selectCurrentMessage = (state) => state.message;
